(function () {
  'use strict';

  if (!window.__smart360LegacyInboxGuard) {
    window.__smart360LegacyInboxGuard = true;

    const selector = 'shopify-agent,#shopify-agent-page-data';
    const removeInboxAgent = function (root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll(selector).forEach(function (element) {
        element.remove();
      });
    };

    removeInboxAgent(document);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(selector)) {
            node.remove();
            return;
          }

          removeInboxAgent(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('load', function () {
      window.setTimeout(function () {
        removeInboxAgent(document);
        observer.disconnect();
      }, 2000);
    });
  }

  const header = document.querySelector('[data-smart-header]');
  if (!header) return;

  const headerBar = header.querySelector('[data-smart-header-bar]');
  const topbar = header.querySelector('.smart-topbar');
  const hideOnScroll = header.dataset.hideOnScroll === 'true';

  /* Announcement carousel: manual arrows only. */
  const announcementSlides = Array.from(header.querySelectorAll('[data-announcement-slide]'));
  const prevAnnouncement = header.querySelector('[data-announcement-prev]');
  const nextAnnouncement = header.querySelector('[data-announcement-next]');
  let announcementIndex = 0;

  function showAnnouncement(index) {
    if (!announcementSlides.length) return;
    announcementIndex = (index + announcementSlides.length) % announcementSlides.length;
    announcementSlides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === announcementIndex);
    });
  }

  if (announcementSlides.length > 1) {
    prevAnnouncement && prevAnnouncement.addEventListener('click', function () {
      showAnnouncement(announcementIndex - 1);
    });
    nextAnnouncement && nextAnnouncement.addEventListener('click', function () {
      showAnnouncement(announcementIndex + 1);
    });
  }

  /* Lightweight desktop search popover. */
  const searchToggle = header.querySelector('[data-search-toggle]');
  const searchPopover = header.querySelector('[data-smart-search]');
  const searchClose = header.querySelector('[data-search-close]');
  const searchInput = header.querySelector('#SmartHeaderSearchInput');

  function openSearch() {
    if (!searchPopover || !searchToggle) return;
    searchPopover.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () {
      searchInput && searchInput.focus();
    }, 20);
  }

  function closeSearch() {
    if (!searchPopover || !searchToggle) return;
    searchPopover.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
  }

  if (searchToggle && searchPopover) {
    searchToggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (searchPopover.hidden) openSearch();
      else closeSearch();
    });

    searchClose && searchClose.addEventListener('click', closeSearch);

    document.addEventListener('click', function (event) {
      if (searchPopover.hidden) return;
      if (header.contains(event.target)) return;
      closeSearch();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSearch();
    });
  }

  /* Mobile drawer. */
  const drawer = header.querySelector('[data-mobile-drawer]');
  const drawerOpen = header.querySelector('[data-mobile-drawer-open]');
  const drawerCloseTriggers = Array.from(header.querySelectorAll('[data-mobile-drawer-close]'));

  function openDrawer() {
    if (!drawer || !drawerOpen) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawerOpen.setAttribute('aria-expanded', 'true');
    document.body.classList.add('smart-mobile-drawer-open');
  }

  function closeDrawer() {
    if (!drawer || !drawerOpen) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawerOpen.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('smart-mobile-drawer-open');
  }

  drawerOpen && drawerOpen.addEventListener('click', openDrawer);
  drawerCloseTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', closeDrawer);
  });

  /* Mobile submenu: parent text is a link; arrow button toggles submenu. */
  const mobileSubmenuToggles = Array.from(header.querySelectorAll('[data-mobile-submenu-toggle]'));
  mobileSubmenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const item = toggle.closest('.smart-mobile-drawer__item');
      if (!item) return;
      const submenu = item.querySelector('.smart-mobile-drawer__submenu');
      const isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (submenu) submenu.hidden = !isOpen;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
      closeSearch();
    }
  });

  /* Desktop hover intent: prevents mega menu from closing when crossing tiny gaps. */
  const navItems = Array.from(header.querySelectorAll('.smart-header__nav-item.has-dropdown'));
  let closeTimer = null;

  navItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (closeTimer) window.clearTimeout(closeTimer);
      navItems.forEach(function (other) {
        if (other !== item) other.classList.remove('is-open');
      });
      item.classList.add('is-open');
    });

    item.addEventListener('mouseleave', function () {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        item.classList.remove('is-open');
      }, 180);
    });
  });

  /* Sticky header bar: top bar scrolls away, header bar sticks. */
  let lastScrollY = window.scrollY || 0;
  let ticking = false;

  function setHeaderMeasurements() {
    if (!headerBar) return;
    header.style.setProperty('--smart-header-bar-height', headerBar.offsetHeight + 'px');
  }

  function updateHeaderState() {
    const currentScrollY = window.scrollY || 0;
    const topbarHeight = topbar ? topbar.offsetHeight : 0;
    const shouldStick = header.classList.contains('smart-header--sticky') && currentScrollY > topbarHeight;
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    header.classList.toggle('is-bar-stuck', shouldStick);

    if (!hideOnScroll || !isDesktop || currentScrollY < 140) {
      header.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    if (currentScrollY > lastScrollY + 8) {
      header.classList.add('is-hidden');
    } else if (currentScrollY < lastScrollY - 8) {
      header.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function requestHeaderUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderState);
      ticking = true;
    }
  }

  setHeaderMeasurements();
  updateHeaderState();
  window.addEventListener('resize', function () {
    setHeaderMeasurements();
    requestHeaderUpdate();
  });
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
})();
